var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormInput',{staticClass:"input",attrs:{"value":_vm.$color,"type":"color","label":"Цвет","placeholder":"Выберите цвет предмета"},on:{"input":_vm.colorChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }